/**
 * file : Home.jsx
 * 설명 : 메인 홈 화면
 */

import editing from "../assets/imgs/editing.png"
import mainSheet from "../assets/imgs/mainSheet.png"
import pivot from "../assets/imgs/pivot.png"
import personalization from "../assets/imgs/personalization.png"
import reaction from "../assets/imgs/reaction.png"
import besides from "../assets/imgs/besides.png"

import { Link } from 'react-router-dom';
import Inquiry from "./Inquiry"
 

export default function Home() {
  return (
    <div>
      {/*======================================= 첫 상단 메인 (Noligo WebSheet) ======================================== */}
      <header className="masthead">
        <div className="container px-4 px-lg-5 h-100">
          <div className="row gx-4 gx-lg-5 h-100 align-items-center justify-content-center">
            <div className="col-lg-8 align-self-end">
                <h1 className="font-weight-bold MainText">웹업무 시스템 <br /> Excel처럼 편하게 입력 되나요?</h1>
            </div>
            <div className="col-lg-8 align-self-baseline text-center">
              <img src={mainSheet} alt="" className="FunctionImg padding-bottom"/>
              <p className="mb-5 MainDetail padding-top">나는 엑셀만 사용하여도 업무에 아무런 문제가 없고 편하게 사용하고 있다<br />
              웹 업무 시스템을 이용하고 잘사용하고 있다<br />
              수기 작업을 하고 있지만 불편함이 전혀없다<br />
              그렇다면 그대로 '뒤로가기'를 누르셔도 됩니다<br /> <br />
              아직 있으신가요?<br />
              그럼  WebSheet를 사용해 볼 것을 강력하게 추천합니다</p>
              <div className="display-flex justify-content-center">
                <Link className="basebtn inquiryclick">문의하기</Link>
                <div className="padding-left-1"><Link to="https://ws.noligo.co.kr/" target="_blank" className="basebtn">블로그 바로가기</Link></div>
              </div>
            </div>
          </div>
        </div>
      </header>
      {/*============================================ Noligo WebSheet란? 부분 ========================================== */}
      <section className="page-section webSheetImg">
          <div className="container px-4 px-lg-5">
              <div className="row gx-4 gx-lg-5 justify-content-center">
                  <div className="col-lg-8 text-center">
                      <h2 className="text-white mt-0">Noligo WebSheet란?</h2>
                  </div>
              </div>
          </div>
      </section>
      {/*===================================== 웹업무를 위한 새로운 제안 부분: START ===================================== */}
      <section className="page-section grayColor">
        <div className="container px-4 px-lg-5 h-100">
          <div className="text-center">
            <div className="padding-bottom">
                <h1 className="mt-0">웹업무를 위한 새로운 제안</h1>
            </div>
            <p className="mb-5 MainDetail padding-top">Noligo WebSheet는 엑셀처럼을 지향하는 업무 맞춤형 제작 서비스입니다<br />
              웹에서 엑셀과 같은 환경을 구성하여 데이터 입력, 수정이 엑셀처럼 간편하고 엑셀에 내용을 간편하게 가져올수 있는것을 최우선으로 생각하는 솔루션입니다 <br />
              이외에도 엑셀 다운로드, 개인화, 컬럼 이동, 정렬, 필터등 다양한 기능을 기본적으로 탑재한 강력한 솔루션 이기도 합니다 <br />
              이런 강력한 기능들로 각 업체들만의 고유 업무를 WebSheet로 간편하고 효율적일 수 있도록 도와드리겠습니다
            </p>
          </div>
        </div>
      </section>
      {/*======================================= 웹업무를 위한 새로운 제안: END ========================================== */}
      {/*======================================== 대표 기능 소개(이미지): START ========================================== */}
      <section className="backgroundImg">
        <div className="container">
          <div className="text-center">
            <h2 className="text-center mt-0 textTitle">대표 기능 소개</h2>
          </div>
          {/*==================================== 유튜브 ==================================== */}
          <div className="container aos-init aos-animate padding-top">
            <div className="video" style={{ paddingBottom: "25px" }}>
              <iframe width="1240" height="750" src={"https://www.youtube.com/embed/4fVDmKmshBE?si=owSTX9pjT1fRiNCV"} title="웹시트홍보영상"></iframe>
            </div>
          </div>
          {/*=================================== 편집 기능 ================================== */}
          <div className="row mx-n5">
            <div className="col-12 col-lg-6 p-5">
              <img src={editing} alt="" className="FunctionImg"/>
            </div>
            <div className="col-12 col-lg-6 d-flex align-items-center p-5">
              <ul>
                <li className="textleft">
                  <h4>편집 기능</h4>
                  <div className="timeline-body">
                    <p className="text-muted">
                      엑셀처럼 간편하게 입력, 수정이 가능 <br />
                      엑셀의 데이터를 복사하여 WebSheet에 바로 붙여넣기 가능 <br />
                      각 컬럼별 정렬, 숨김, 위치이동 등 기능이 기본 내장 <br />
                    </p>
                  </div>
                  <Link to="https://ws.noligo.co.kr/14" target="_blank" className="borderbtn">자세히 보기</Link>
                </li>
              </ul>
            </div>
          </div>
          {/*=================================== PLVOT 기능 ================================== */}
          <div className="row flex-row-reverse mx-n5 mt-5">
            <div className="col-12 col-lg-6 p-5 textright">
              <img src={pivot} alt="" className="FunctionImg" />
            </div>
            <div className="col-12 col-lg-6 d-flex align-items-center p-5 text-lg-right">
              <ul>
                <li className="textright">
                  <h4>PIVOT 기능</h4>
                  <div className="timeline-body"><p className="text-muted">엑셀과 비슷한 형태의 PIVOT기능 제공</p></div>
                  <Link to="https://ws.noligo.co.kr/15" target="_blank" className="borderbtn">자세히 보기</Link>
                </li>
              </ul>
            </div>
          </div>
          {/*=================================== 개인화 기능 ================================== */}
          <div className="row mx-n5">
            <div className="col-12 col-lg-6 p-5 textleft">
              <img src={personalization} alt="" className="FunctionImg" />
            </div>
            <div className="col-12 col-lg-6 d-flex align-items-center p-5">
              <ul>
                <li className="textleft">
                  <h4>개인화 기능</h4>
                  <div className="timeline-body">
                    <p className="text-muted">
                      컬럼 이동, 숨김 등 설정을 저장하는 기능 <br />
                      각 유저별로 설정가능하여 로그인 한 유저마다 보고 싶은 형태를 유지함
                    </p>
                  </div>
                  <Link to="https://websheet.tistory.com/16" target="_blank" className="borderbtn">자세히 보기</Link>
                </li>
              </ul>
            </div>
          </div>
          {/*=================================== 반응형 웹 ================================== */}
          <div className="row flex-row-reverse mx-n5 mt-5">
            <div className="col-12 col-lg-6 p-5 textright">
              <img src={reaction} alt="" className="FunctionImg" />
            </div>
            <div className="col-12 col-lg-6 d-flex align-items-center p-5 text-lg-right">
              <ul>
                <li className="textright" data-wow-delay="0s">
                  <h4>반응형 웹</h4>
                  <div className="timeline-body"><p className="text-muted">모든 해상도에서 반응하며 모바일에서도 검색 및 조작 가능<br />(단, 너무 작은 화면에서는 보기 어려울 수 있습니다.)</p></div>
                  <Link to="https://websheet.tistory.com/17" target="_blank" className="borderbtn">자세히 보기</Link>
                </li>
              </ul>
            </div>
          </div>
          {/*===================================== 기타 ===================================== */}
          <div className="row mx-n5">
            <div className="col-12 col-lg-6 p-5 textleft">
              <img src={besides} alt="" className="FunctionImg" />
            </div>
            <div className="col-12 col-lg-6 d-flex align-items-center p-5">
              <ul>
                <li className="textleft">
                  <h4>기타</h4>
                  <div className="timeline-body">
                    <p className="text-muted">
                      메인화면 대쉬보드 <br />
                      사용자 관리 <br />
                      사용자별 메뉴 권한 관리
                    </p>
                  </div>
                  <div className="display-flex">
                    <Link to="https://websheet.tistory.com/6" target="_blank" className="borderbtn">메인 화면</Link>
                    <div className="padding-left-1"><Link to="https://websheet.tistory.com/9" target="_blank" className="borderbtn">사용자 관리</Link></div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className="text-center padding-top">
              <h2 className="text-center subtitle">그 외에도 많은 기능을 제공하고 있습니다</h2>
            </div>
        </div>
      </section>
      {/*========================================= 대표 기능 소개(이미지): END =========================================== */}
      {/*============================================= 가격 정책: START ================================================= */}
      <section className="page-section">
        <div className="container aos-init aos-animate">
          <div className="text-center">
            <h2 className="text-center mt-0 textTitle">가격 정책</h2>
          </div>
          <div className="row center padding-top">
            <div className="col-md-6 aos-init aos-animate">
              <div className="price">
                <h3 className="center">Basic</h3>
                <h4>150,000</h4>
                <div className="text-muted padding-bottom">+ 페이지 당 70,000 ~</div>
                <ul className="noPadding">
                  <li>회원관리</li>
                  <li>메뉴관리</li>
                  <li>메뉴권한 관리 등등</li>
                </ul>
                <div className="btn-wrap">
                  <Link className="btn-buy inquiryclick" id="inquiry">Buy Now</Link>
                </div>
              </div>
            </div>
            <div className="col-md-6 mt-4 mt-md-0 aos-init aos-animate">
              <div className="price featured">
                <h3 className="center">Enterprise</h3>
                <h4>별도 협의</h4>
                <ul className="noPadding">
                  <li>회원관리</li>
                  <li>메뉴관리</li>
                  <li>메뉴 권한 관리</li>
                  <li>개발을 위한 UI 소스 제공 등등</li>
                </ul>
                <div className="btn-wrap">
                  <Link className="btn-buy inquiryclick" id="inquiry">Buy Now</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*============================================== 가격 정책: END ================================================== */}
      {/*======================================= 여기서 잠깜만요 부분: START ============================================= */}
      <section className="page-section grayColor ">
        <div className="container px-4 px-lg-5 h-100">
          <div className="row gx-4 gx-lg-5 h-100 align-items-center justify-content-center">
            <div className="col-lg-8 align-self-end">
                <h3 className="mt-0">​여기서 잠깜만요</h3>
                <h1 className="font-weight-bold MainText">Let's Start Sale</h1>
            </div>
            <div className="col-lg-8 align-self-baseline">
              <p className="mb-5 MainDetail padding-top">
                여기까지 내려 오시느라 고생하셨습니다 <br />
                잠시 집중하여 읽어 주셨으면 합니다 <br /><br />
                저희는 많은 개발 경험을 가지고 있지만 Noligo WebSheet 프레임웍을<br /> 이용한 서비스는 시작 단계라고 할 수 있습니다<br /><br />
                여러분의 믿고 진행해주시길 기원하는 마음으로 한가지 고객님에게 제시하려고 합니다<br />
                마음에 들지 않을 시 100% 환불을 약속 드리 겠습니다 <br /><br />
                또한, 만족하신다면 Noligo WebSheet를 위하여 후기를 작성하여 주시고 블로그에 후기 주소를 댓글로<br />
                남겨주신다면 확인 후 기본금액인 150,000원을 모두 돌려드리겠습니다<br /><br />
                ​좀 더 궁금한 사항은 More Info를 클릭하여 주세요
              </p>
              <Link to="https://ws.noligo.co.kr/" target="_blank" className="basebtn">More Info</Link>
            </div>
          </div>
        </div>
      </section>
      {/*======================================== 여기서 잠깜만요 부분: END ============================================== */}
      {/*========================================== 문의하기 부분: START ================================================ */}
      <Inquiry />
      {/*=========================================== 문의하기 부분: END ================================================= */}
    </div>
  )
}